import React from 'react';
import { MessageSquare, Brain, FileCheck, ArrowDown } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    {
      id: 1,
      icon: MessageSquare,
      title: 'Describe Your Situation',
      description: 'Simply explain your matter in everyday language. Our AI will understand the context and implications.',
      color: 'from-blue-500 to-blue-600'
    },
    {
      id: 2,
      icon: Brain,
      title: 'Receive Expert Analysis',
      description: 'Our AI analyzes your situation, identifies relevant principles, and determines the best course of action.',
      color: 'from-indigo-500 to-indigo-600'
    },
    {
      id: 3,
      icon: FileCheck,
      title: 'Get Actionable Solutions',
      description: 'Receive step-by-step guidance, custom templates, and recommended actions tailored to your specific situation.',
      color: 'from-purple-500 to-purple-600'
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            How TheEqualizer.AI Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Get professional guidance in three simple steps
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {steps.map((step, index) => (
            <div key={step.id} className="relative">
              <div className="flex flex-col md:flex-row items-center gap-8 mb-12">
                {/* Step Icon */}
                <div className="flex-shrink-0">
                  <div className={`w-20 h-20 bg-gradient-to-br ${step.color} rounded-2xl flex items-center justify-center shadow-xl`}>
                    <step.icon className="w-10 h-10 text-white" />
                  </div>
                  <div className="w-12 h-12 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center -mt-6 ml-4 shadow-lg">
                    <span className="text-lg font-bold text-gray-700">{step.id}</span>
                  </div>
                </div>

                {/* Step Content */}
                <div className="flex-1 text-center md:text-left">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{step.title}</h3>
                  <p className="text-lg text-gray-600 leading-relaxed">{step.description}</p>
                </div>
              </div>

              {/* Arrow Between Steps */}
              {index < steps.length - 1 && (
                <div className="flex justify-center mb-12 md:ml-10">
                  <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
                    <ArrowDown className="w-4 h-4 text-gray-400" />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Ready to Get Started?</h3>
            <p className="text-gray-600 mb-6">Join thousands of users who have resolved their matters with our AI assistant.</p>
            <button 
              className="bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white px-8 py-3 rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
              onClick={() => document.getElementById('pricing').scrollIntoView({ behavior: 'smooth' })}
            >
              Get Started Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;